import { ObjectId } from 'bson'
import chalk from 'chalk'
import prompts from 'prompts'
import { writeConfig } from '../get-project-config'

import { getLogger } from '@hashnode/file-parsing'

const logger = getLogger()

export async function initProjectConfig(cwd: string) {
	const { linkedProjectId } = await prompts({
		type: 'text',
		name: 'linkedProjectId',
		message: `Configuration is missing. Enter the project ID. You can find it in the ${chalk.green(
			`project's dashboard`,
		)}`,
	})

	if (!ObjectId.isValid(linkedProjectId)) {
		logger.error('Invalid project ID')
		process.exit(1)
	}

	const config = await writeConfig(cwd, {
		linkedProjectId,
	})

	return config
}
